export default __webpack_public_path__ + "static/media/fmcg.d4f51796.png";